import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";

// Types
import AuthenticatedUserContextType from "../../types/AuthenticaterUserContext";

// Sendbird
import sendbirdSelectors from "@wearesweet/sendbird-uikit-react/sendbirdSelectors";
import withSendbird from "@wearesweet/sendbird-uikit-react/withSendbird";

// Contexts
import { faMessageLines } from "@fortawesome/pro-regular-svg-icons";
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";
import IconButton from "../Button/Icon/IconButton";

class MemberChatLink extends React.Component<any, any> {
  private sb: any = null;

  render() {
    const { member } = this.props;
    return <IconButton icon={faMessageLines} tooltip="Chat" align="left" onClick={member.status !== "blocked" && this.chatWith ? this.chatWith : undefined} />;
  }

  chatWith = () => {
    const { memberTarget, t } = this.props;
    const { member } = this.context as AuthenticatedUserContextType;
    if (this.props.sb !== null) {
      const { groupChannel } = this.props.sb;

      const newChannelParams = {
        invitedUserIds: [member!.id.toString(), memberTarget.id.toString()],
      };

      groupChannel
        .createChannel(newChannelParams)
        .then((channel: any) => {
          this.props.history.push(`/chat/channels/${channel.url}`);
        })
        .catch((error: any) => alert(error));
    } else {
      alert(t("errorOpeningChat"));
    }
  };
}

MemberChatLink.contextType = AuthenticatedUserContext;

const MemberChatLinkWithSendbird: any = withSendbird(MemberChatLink, (state: any) => ({
  sb: sendbirdSelectors.getSdk(state),
  connect: sendbirdSelectors.getConnect(state),
}));

const firstHoc = withRouter(MemberChatLinkWithSendbird);
export default withTranslation()(firstHoc);
